/* loaded by smart-asset */
export default require("./check-square-regular~bfuEdNti.svg")